<template>
  <div class="helpContractConfirm">
    <help-header />
    <v-divider class="helpContractConfirm_divider" />
    <section class="helpContractConfirm-need_details">
      <section class="helpContractConfirm-need_details-item">
        <span class="helpContractConfirm-need_details-title"
          >メールアドレス</span
        >
        <p class="helpContractConfirm-need_details-text">{{ userEmail }}</p>
      </section>
      <section class="helpContractConfirm-need_details-item">
        <span class="helpContractConfirm-need_details-title"
          >お問い合わせの種類</span
        >
        <p class="helpContractConfirm-need_details-text">
          {{ currentCategory.title }} -
          {{ currentTopic.title }}
          <template v-if="currentQuestion.question">
            -<br />
            Q{{ currentQuestion.index + 1 }} {{ currentQuestion.question }}
          </template>
        </p>
      </section>
    </section>
    <section class="helpContractConfirm_content">
      <h4>お問い合わせ内容</h4>
      <p class="helpContractConfirm_body">
        {{ currentTopic.input }}
      </p>
    </section>
    <section
      v-if="selectedCam && currentTopic.showCamSelect"
      class="helpContractConfirm_content"
    >
      <h4>ご質問対象のカメラ</h4>
      <p>
        {{ selectedCam.name }}
      </p>
    </section>
    <section
      v-if="selectedCam && currentTopic.showCamSelect"
      class="helpContractConfirm_content"
    >
      <h4>カメラ映像の閲覧を許可{{ allowCam ? '' : 'しない' }}</h4>
    </section>
    <section class="helpContractConfirm-actions">
      <v-btn text class="helpContractConfirm-return" @click="handleBack"
        >前の画面に戻る</v-btn
      >
      <v-btn
        class="helpContractConfirm-save"
        :disabled="isDisable"
        :loading="loading"
        @click="handleEmail"
        >送信</v-btn
      >
    </section>
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HelpHeader from '../HelpHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'HelpContractConfirm',
  components: {
    HelpHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogMessageText: '',
      isDisable: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
      selectedCam: (state) => state.help.selectedCam,
      allowCam: (state) => state.help.allowCam,
      userInfo: (state) => state.common.userInfo,
      currentAvatarId: (state) => state.settings.currentAvatarId,
    }),
    currentCategory() {
      return this.helpCategories.find(
        (item) => item.id === this.$route.params.id
      );
    },
    currentTopic() {
      return (
        (this.currentCategory.sub_topic || []).find(
          (item) => item.id === this.$route.params.topic
        ) || {}
      );
    },
    questions() {
      return this.currentTopic.list || [];
    },
    currentQuestion() {
      if (!this.questions) return {};

      return (
        (this.questions || []).find(
          (item) => item.id === this.$route.params.qid
        ) || {}
      );
    },
    username: () => 'セコム 太郎',
    userEmail() {
      return this.userInfo && this.userInfo.attributes
        ? this.userInfo.attributes.email
        : '';
    },
  },
  watch: {
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  mounted() {
    if (this.$route.query.dl === 1) {
      this.displayDeleteMessage();
    }
  },
  methods: {
    ...mapActions('help', [
      'setTopicInput',
      'postUserInquiry',
      'setAllowCam',
      'setSelectedCam',
    ]),
    async handleEmail() {
      const payload = {
        avatar_id: this.currentAvatarId,
        topic: this.currentCategory.title,
        sub_topic: this.currentTopic.title,
        subject: `${this.currentTopic.title}`,
        body: this.currentTopic.input,
        ope_browse_flag: 0,
      };
      if (this.selectedCam) {
        payload.camera_id = this.selectedCam.id;
        payload.ope_browse_flag = this.allowCam ? 1 : 0;
      }
      try {
        this.loading = true;
        await this.postUserInquiry(payload);
        this.navigateTo({
          name: 'help-email',
        });
        this.setAllowCam(false);
        this.setTopicInput({
          input: '',
          categoryId: this.currentCategory.id,
          topicId: this.currentTopic.id,
        });
        this.setSelectedCam(null);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleBack() {
      this.$router.go(-1);
    },
    navigateTo(route) {
      this.routerPush(route);
    },
    displayDeleteMessage() {
      this.dialogMessageText = 'グループを削除しました。';
      this.$router.replace({ query: null });
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.helpContractConfirm {
  &_divider {
    margin-top: 15px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &-q_index {
    width: 30px;
    margin-right: 5px;
    display: inline-block;
  }
  &_body {
    white-space: pre-wrap;
  }
  &_title {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
  }
  &-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }
  &-need {
    margin-top: 32px;
    margin-bottom: 10px;
    font-size: 14px;
    text-align: left;
    color: #666;
    &_input {
      &-bottom {
        &_message,
        &_counter {
          font-size: 12px;
          text-align: left;
          color: #989898;
        }
        &_counter {
          em {
            &.error {
              color: #eb545b;
              background-color: unset !important;
            }
            &.not-exceed {
              color: #0075c2;
              background-color: unset !important;
            }
          }
        }
      }
    }
    &_note {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-top: 11px;
      border-bottom: 1px solid #eeeeee;
      border-top: 1px solid #eeeeee;
      padding: 10px 0;
    }
    &_box {
      margin-top: 11px;
      box-shadow: 0 1px 0 0 #eee;
      background-color: #f3f3f3;
      padding: 15px;

      .v-textarea {
        &.v-text-field {
          &--outlined:not(.v-input--is-focused):not(.v-input--has-state)
            > .v-input__control
            > .v-input__slot
            fieldset {
            border-radius: 5px;
            border: solid 2px #ccc;
            background-color: #fff;
          }
          &--enclosed {
            .v-text-field__details {
              padding: 0;
            }
            .v-text-field__slot textarea {
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.38;
              letter-spacing: normal;
              text-align: left;
              color: #666;
              &::placeholder {
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.38;
                letter-spacing: normal;
                text-align: left;
                color: #ccc;
              }
            }
          }
        }
      }
      &-title {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
        margin-bottom: 10px;
      }
    }
    &_details {
      margin-top: 15px;
      &-item {
        display: flex;
      }
      &-title {
        width: 150px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      &-text {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        word-wrap: break-word;
      }
    }
  }
  &_content {
    padding: 15px 0;
    max-height: 510px;
    overflow-y: auto;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;

    & > h4 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
      margin-bottom: 10px;
    }
    & > p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      word-wrap: break-word;
      max-width: 100%;
    }
  }

  &_item {
    padding: 15px 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    &:last-child {
      border-bottom: 1px solid #eee;
    }
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
    &-details {
      margin-top: 10px;
      h5 {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
    }
  }
  &-collapse {
    cursor: pointer;
    display: inline-block;
    h5 {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &--icon {
      margin-left: 5px;
      color: #c1c1c1 !important;
    }
  }
  &-save {
    &.v-btn:not(.v-btn--round).v-size--default {
      width: 120px;
      height: 36px;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
    }
    &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #f3f3f3 !important;
      box-shadow: none;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ccc !important;
    }
  }
  &-return {
    &.v-btn:not(.v-btn--round).v-size--default {
      padding: 0;
    }
  }
}
</style>
